export const baseData = {
  title: "PRODUCT STYLE"
}